import { CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import OutlineTabGroup from 'src/components/base/outline-tabs/outline-tab-group/outline-tab-group';
import componentStyles from './idb-tab-group.css.lit';

/**
 * The IdbTabGroup component
 * @element idb-tab-group
 *
 * @slot - Used for grouping tab panels in the tab group.
 * @slot nav - Used for grouping tabs in the tab group.
 */
@customElement('idb-tab-group')
export class IdbTabGroup extends OutlineTabGroup {
  static styles: CSSResultGroup = [OutlineTabGroup.styles, componentStyles];

  @property({ type: String, attribute: 'placement' })
  placement: 'top' | 'bottom' | 'start' | ('end' & 'left') = 'start';

  connectedCallback() {
    super.connectedCallback();
    this.placement = 'top';
    this.tabGroupCompName = 'idb-tab-group';
    this.tabCompName = 'idb-tab';
    this.tabPanelCompName = 'idb-tab-panel';
  }
}
